import { EMAIL_TOKENS } from "../../styles/tokens";
import { applyStyleMap } from "../shared-block-styles";

import { CSSProperties } from "react";

import type { ButtonAttrs } from "./definition";

/** Map legacy preset keys to px values. */
const RADIUS_PRESETS: Record<string, string> = {
  sm: "4px",
  md: "8px",
  lg: "12px",
  full: "9999px",
};

function resolveRadius(value: string): string {
  return RADIUS_PRESETS[value] ?? value;
}

export function getButtonStyles(attrs: ButtonAttrs): CSSProperties {
  const borderWidthPx = parseInt(attrs.borderWidth || "0", 10);

  const styles: CSSProperties = {
    display: "inline-block",
    padding: `${attrs.paddingVertical || EMAIL_TOKENS.spacing.sm} ${attrs.paddingHorizontal || EMAIL_TOKENS.spacing.lg}`,
    backgroundColor: attrs.backgroundColor,
    color: attrs.textColor,
    borderRadius: resolveRadius(attrs.borderRadius),
    fontFamily: EMAIL_TOKENS.fontFamily.sans,
    fontSize: EMAIL_TOKENS.fontSize.base,
    fontWeight: 600,
    textDecoration: "none",
    textAlign: "center" as const,
    lineHeight: EMAIL_TOKENS.lineHeight.normal,
    ...(borderWidthPx > 0
      ? {
          borderWidth: attrs.borderWidth,
          borderStyle: (attrs.borderStyle ||
            "solid") as CSSProperties["borderStyle"],
          borderColor: attrs.borderColor || "#000000",
        }
      : { border: "none" }),
  };

  // A call-to-action lifted out of a designed template keeps its own
  // typography, spacing and `mso-*` hints; the block's defaults are only what
  // fills in underneath.
  applyStyleMap(styles, attrs);

  return styles;
}

export function getButtonWrapperStyles(
  alignment: ButtonAttrs["alignment"],
): CSSProperties {
  return {
    textAlign: alignment,
  };
}
